module.exports = "/_next/static/images/ActivateUnify-a13233b389708ebbef55c84610ff86e5.webp";